import React, { useCallback, useMemo, useState } from 'react';
import SubmitButton from '@/components/Checkout/components/SubmitButton';
import cx from 'classnames';
import { useRouter } from 'next/router';
import { writeToLocalStorage } from '@/components/Checkout/utils/CheckoutProcess';
import { useAnalytics } from '@/analytics/AnalyticsProvider';
import { useMeasure } from 'react-use';
import { EducatorSelected, ParentSelected, StudentSelected, UserTypeSelected, UserTypeSubmitted } from '@/analytics/events';
import * as Events from '@/analytics/events';
import { MUZOLOGY_APP } from '@/lib/defaults';

const CheckoutChild1 = ({ isLoading, setLoading, nextStage }) => {
    const analytics = useAnalytics();
    const router = useRouter();
    const { email, token } = router.query ?? {};
    const [ref, { width }] = useMeasure();

    const [userAction, setUserAction] = useState(null);

    const users = [
        {
            id: 'join',
            actionCopy: 'Use Class Join Code',
            copy: 'My teacher gave me a Join Code.',
            color: '#1CC8E1'
        },
        {
            id: 'login',
            actionCopy: 'Log In Again',
            copy: "I've already used Muzology.",
            color: '#6F5FE6'
        },
        {
            id: 'signup',
            actionCopy: 'Join Today',
            copy: 'I just found this site and want to try it!',
            color: '#FADF58'
        }
    ];



    const submitUser = (userAction) => {
        console.log('submitting user type', userAction);
        switch (userAction) {
            case 'Use Class Join Code':
                window.location.href = `${MUZOLOGY_APP}/join`;
                break;
            case 'Log In Again':
                nextStage({ stage: 4 });
                break;
            case 'Join Today':
                nextStage({ stage: 2 });
                break;
            default:
                return null;
        }
    };

    const handleSetUserAction = useCallback(
        (userAction) => {
            submitUser(userAction);
        },
        [submitUser]
    );

    const createUsers = useMemo(() => {
        return users.map((user, index) => {
            const isSelected = user.actionCopy === userAction;
            const classes = cx(
                'w-[286px] sm:w-[195px] md:w-[238px] lg:w-[238px] h-[200px] sm:h-[280px]   p-2 border-solid border-[.74px] border-[#BCBCBC] rounded-lg bg-white cursor-pointer select-none',
                {
                    'bg-checkout-plan-selected shadow-checkout-plan-selected': isSelected,
                    'hover:bg-[#5F42CD] active:bg-[#342274]': !isSelected
                }
            );

            return (
                <button
                    id={user.actionCopy}
                    key={user.actionCopy}
                    className={classes}
                    style={{ boxShadow: '0px 2.998px 2.998px 0px rgba(112, 108, 108, 0.25)' }}
                    onClick={() => handleSetUserAction(user.actionCopy)}
                    aria-label={user.actionCopy}
                >
                    <div className='bg-white rounded-lg font-Poppins h-full w-full'>
                        <div className=''>
                            <div className='text-black text-base md:text-[18px] font-normal text-center max-w-[204px] mx-auto pt-2 sm:pt-8'>{user.copy}</div>
                            <div className={cx('flex items-center justify-center', { 'my-5 sm:my-7': index === 0 }, { 'mt-5 sm:mt-[52px] mb-5 sm:mb-7': index !== 0 })}>
                                <div className='w-[152px] h-2.5 rounded-2xl' style={{ background: user.color }} />
                            </div>
                            <div className='flex justify-center items-center h-[70px]'>
                                <div className='text-2xl md:text-[30px] font-medium leading-tight max-w-[200px]  text-black'>{user.actionCopy}</div>
                            </div>
                        </div>
                    </div>
                </button>
            );
        });
    }, [handleSetUserAction, userAction, users, width]);

    return (
        <div
            ref={ref}
            className='select-none font-Poppins mt-6 sm:mt-12 min-h-[900px] sm:min-h-[100%] bg-checkout-timestables-background sm:bg-none pt-1 sm:pt-0'
        >
            <div className='max-w-[1000px] mx-auto text-left sm:pl-5 lg:pl-0'>
                <h1 className='m-0 hidden sm:block text-[44px] font-semibold'>Let's Get Started!</h1>
                <div className='hidden  text-[#4E4E4E] text-xl font-light text-center sm:text-left max-w-[3600px] sm:max-w-full mx-auto sm:mx-0 px-4 sm:px-0'>
                    Learn Smarter. Not Harder. Muzology will Help Make Math Fun & Easy!
                </div>
            </div>
            <div className='flex flex-col sm:flex-row gap-8 sm:gap-3 md:gap-6 lg:gap-10 w-full justify-center items-center mt-16'>{createUsers}</div>
        </div>
    );
};

export default CheckoutChild1;
